import { Adapter } from './adapter';
import { AdditionalField } from '../models/additional-field.model';
import { AdditionalFieldInterface } from '@app/interfaces/_index';

/**
 * Adapt raw service from Docebo additional course fields object to AdditionalField model
 * NOTE: The item fields are the default json property names.
 */
export class AdditionalFieldAdapter implements Adapter<AdditionalField> {
  /**
   * Adapt data item into a AdditionalField model.
   * @param item - data item AdditionalField Interface to be transformed
   * @returns - returns an adapted AdditionalField model
   */
  adapt(item: AdditionalFieldInterface): AdditionalField {
    let additionalField: AdditionalField;
    if (item) {
      additionalField = new AdditionalField(
        item.id,
        item.title,
        item.type,
        item.value,
        item.visible_to_user
      );
    }

    return additionalField;
  }
}
